import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useStoryActions} from '../../../../entities';
import {useNavigate} from 'react-router';

interface DeleteStoryByIdModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  storyId: string;
  blockId?: string;
  appealId?: string;
  projectStoryId?: string;
}

export const DeleteStoryByIdModal = ({
  open,
  setOpen,
  storyId,
  blockId,
  appealId,
  projectStoryId,
}: DeleteStoryByIdModalProps) => {
  const {deleteStoryMutation} = useStoryActions();
  const navigate = useNavigate();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'История',
    title: 'Ошибка при удалении истории',
  });

  useEffect(() => {
    if (deleteStoryMutation.error) {
      handleError(deleteStoryMutation.error as unknown as ApiError);
    }
  }, [deleteStoryMutation.error, handleError]);

  const handleDeleteStory = async () => {
    try {
      await deleteStoryMutation.mutateAsync(storyId);
      setOpen(false);
      if (appealId) {
        navigate(`/fundraisings/appeals/${appealId}`);
      } else if (blockId) {
        navigate(`/content/blocks/${blockId}`);
      }
      if (projectStoryId) {
        navigate(`/content/project-stories/${projectStoryId}`);
      }
    } catch (error) {}
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleDeleteStory}
        isLoading={deleteStoryMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление истории'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить эту историю? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
